import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAutoCarport = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M8 32V16l12-8 12 8v16"
    />
    <path
      fill="#0061CD"
      d="M28 30a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0z"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M28 26H12l2.15-4.83A1.8 1.8 0 0 1 15.73 20h8.54a1.8 1.8 0 0 1 1.58 1.17z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M28.9 26H11.1a1.1 1.1 0 0 0-1.1 1.1v3.8a1.1 1.1 0 0 0 1.1 1.1h17.8a1.1 1.1 0 0 0 1.1-1.1v-3.8a1.1 1.1 0 0 0-1.1-1.1"
    />
    <path
      fill="#0061CD"
      d="M16 30a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M26.47 26H13.53l1.74-4a1.45 1.45 0 0 1 1.28-1h6.9a1.45 1.45 0 0 1 1.28 1z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M14 30.83a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M26 30.83a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M30 19H10v-2h20z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m23.677 8.416-8.18 5.45-.554-.832 8.18-5.45zM32.99 22.94H30v-1h3.99V32h-1z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAutoCarport);

export default ForwardRef;
